import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'
import { updateBettingPropertiesOnDataLayer } from '../dataLayer/updaters'

/*
 * ⚠️ Common Tracking Functions Only
 *    - Ideally use co-location if possible (analytics.ts helper file)
 *    - Place here if shared across Areas etc
 */

export function trackInfinityScrollEvent({
  location,
  loadCount,
}: {
  location: 'Pending Bets' | 'Resulted Bets' | 'Debit / Credit' | 'Re-Bet'
  loadCount: number
}) {
  trackEvent(keys.infinityScroll, { location, loadCount: `${loadCount}` })
}

export function trackBonusBetEvent(
  eventName: BonusBetEventKeys,
  metadata: {
    accountNumber: string | number | null
    accountBalance: number | null
    bonusBetBalance: number | null
    bonusCashBalance: number | null
    [key: string]: unknown
  }
) {
  trackEvent(eventName, metadata)
}

export function trackBettingEvent(
  key: BettingEventKeys,
  data: Parameters<typeof updateBettingPropertiesOnDataLayer>[0]
) {
  trackEvent(key, data)
  updateBettingPropertiesOnDataLayer(data)
}

// =====
// Types
// =====

type BonusBetEventKeys =
  | typeof keys.quickbetBonusCashRemoved
  | typeof keys.quickbetBonusBetAddedToBetslip
  | typeof keys.quickbetBonusBetProposed
  | typeof keys.quickbetBonusCashUnselected
  | typeof keys.quickbetBonusCashSelected
  | typeof keys.quickbetBonusBetUnselected
  | typeof keys.quickbetBonusBetSelected
  | typeof keys.betslipBonusBetConfirmed
  | typeof keys.betslipBonusBetConfirmed
  | typeof keys.quickbetBonusBetButtonDeactivated
  | typeof keys.quickbetBonusBetButtonActivated
  | typeof keys.quickbetBonusBetButtonShown
  | typeof keys.accountDropDownOpened

type BettingEventKeys =
  | typeof keys.betAccountProcessed
  | typeof keys.betAccountSelected
  | typeof keys.betAccountReview
  | typeof keys.quickbetOpen
  | typeof keys.quickbetClosed
